export default "__VITE_ASSET__Cf9paPSp__"